import { render, staticRenderFns } from "./EditArchive.vue?vue&type=template&id=42ccea3e&scoped=true"
import script from "./EditArchive.vue?vue&type=script&lang=js"
export * from "./EditArchive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ccea3e",
  null
  
)

export default component.exports